export const GET_SUBLINE = 'GET_SUBLINE';
export const SET_SUBLINE = 'SET_SUBLINE';
export const ERROR_SUBLINE = 'ERROR_SUBLINE';